import React, { useState } from 'react';
import './Blogs.scss';
import { blogsData } from './partials/BlogsData/BlogsData';
import BlogsCard from './partials/BlogsCard/BlogsCard';
import { useNavigate } from 'react-router-dom';

export default function Blogs() {
  const [selectedBlog, setSelectedBlog] = useState(blogsData[0]);
  const navigate = useNavigate();

  const handleBlogClick = (blog, index) => {
    if (window.innerWidth <= 800) {
      navigate(`/blog/${index}`);
    } else {
      setSelectedBlog(blog);
    }
  };

  return (
    <div className='blogs-container'>
      <h1>Blogs</h1>
      <div className='blogs-wrapper'>
        <div className='left-blog-list'>
          <h4>Blog Posts</h4>
          {blogsData.map((blog, index) => (
            <div key={index} onClick={() => handleBlogClick(blog, index)}>
              <BlogsCard image={blog.image} heading={blog.heading} />
            </div>
          ))}
        </div>
        <div className='right-blog-details'>
          <div className='image-container-blog'>
            <img src={selectedBlog.image} alt={selectedBlog.heading} />
          </div>
          <h2>{selectedBlog.heading}</h2>
          {Array.isArray(selectedBlog.description) ? (
            selectedBlog.description.map((para, idx) => <p key={idx}>{para}</p>)
          ) : (
            <p>{selectedBlog.description}</p>
          )}
        </div>
      </div>
    </div>
  );
}
